import 'font-awesome/css/font-awesome.min.css';
import { BASE_URL } from "../url";
import {Link, useNavigate} from "react-router-dom";
import {getAuth, onAuthStateChanged,signOut} from 'firebase/auth';
import { initializeApp } from "firebase/app";
import { database } from '../config';
import {useEffect, useState,} from "react";

export default function Header() {

  const [loggedIn, setLoggedIn] = useState(null);

  const firebaseConfig = {
    apiKey: "AIzaSyCnA-AjTxO8Y6BdHo9CKwZSLOrtXryzZnk",
    authDomain: "hollas-price-portal.firebaseapp.com",
    projectId: "hollas-price-portal",
    storageBucket: "hollas-price-portal.appspot.com",
    messagingSenderId: "1039107084906",
    appId: "1:1039107084906:web:921f6cdbf4955a7dedb013"
  };

  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);

  useEffect(() => {
    const checkLoggedIn = onAuthStateChanged(auth, (authUser) => {
      if (authUser) {
        setLoggedIn(authUser);
      } else {
        setLoggedIn(null);
      }
    });
    return () => checkLoggedIn();
  }, []);

  const history = useNavigate()
  const logout = ()=>{
    signOut(database).then(data=>{
      history('/login')
    })
  }

  return (
    <header>
    <Link to="/home" className="logo"><span className="fontColor">H</span>OLLA'S TV CENTER</Link>
    <nav>
      {loggedIn ? (
        <>
          <button className='addPrdBtn'><Link to="/create">ADD PRODUCT</Link></button>
          <button><a onClick={logout} className="logout">LOGOUT</a></button>
        </>
      ) : (
        <button><Link to="/login">LOGIN</Link></button>
      )}
    </nav>
  </header>
  );
}
